// extracted by mini-css-extract-plugin
export default {"component":"MoveOfficeModal_component__5PhrS","modalContainer":"MoveOfficeModal_modalContainer__TRdAZ","input":"MoveOfficeModal_input__VY4-j"};